import { PropsWithChildren } from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { To, Link as RRLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

interface LinkProps extends PropsWithChildren<BoxProps> {
  to: To;
  component?: "link" | "hash-link";
  target?: string;
  onClick?: React.MouseEventHandler;
}

export function Link({
  to,
  component,
  children,
  onClick,
  ...props
}: LinkProps) {
  return (
    <Box
      textDecoration="underline"
      display="inline-block"
      color="brand.blue.primary"
      _hover={{ color: "brand.blue.light" }}
      {...props}
    >
      {props.target?.toLowerCase() === "_blank" ? (
        <a href={to.toString()} target="_blank" onClick={onClick}>
          {children}
        </a>
      ) : component === "hash-link" ? (
        // @ts-expect-error type issues
        <HashLink {...props} to={to} onClick={onClick}>
          {children}
        </HashLink>
      ) : (
        <RRLink to={to} onClick={onClick}>
          {children}
        </RRLink>
      )}
    </Box>
  );
}
